import React from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './LoginPage';
import MainPage from './MainPage';
import SignInButton from './SignInButton';
import GroupList from './GroupList';
import MessageSender from './MessageSender';

const msalConfig = {
    auth: {
        clientId: '9a6239f8-2c3f-4362-accc-a2240387d29d',
        authority: 'https://login.microsoftonline.com/49759be7-8ef2-40e0-8e7c-68c33e9cd5fc',
        redirectUri: window.location.origin,
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false
    }
};

const msalInstance = new PublicClientApplication(msalConfig);

// Handle redirect promise on app initialization
msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
        msalInstance.setActiveAccount(response.account);
    } else {
        // Check if there are any accounts already signed in
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }
    }
}).catch((error) => {
    console.error('Redirect error:', error);
});

function App() {
    const [selectedGroupIds, setSelectedGroupIds] = React.useState([]);

    const handleGroupSelect = (groupId) => {
        setSelectedGroupIds(prevSelected => {
            if (prevSelected.includes(groupId)) {
                return prevSelected.filter(id => id !== groupId);
            } else {
                return [...prevSelected, groupId];
            }
        });
    };

    return (
        <MsalProvider instance={msalInstance}>
            <Router>
                <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/main" element={<MainPage selectedGroupIds={selectedGroupIds} handleGroupSelect={handleGroupSelect} />} />
                </Routes>
            </Router>
        </MsalProvider>
    );
}

export default App;
